export const stateName = 'savedSearches';
export const SEARCH_CHECK_DEBOUNCE_AMOUNT = 300;